import React, { useEffect, useState } from 'react';
import Modal from '../common/Modal';
import ConfirmDialog from '../common/ConfirmDialog';
import './ModalForms.css';
import '../common/IconButton.css';
import { digitsOnly, formatCuil, formatDni } from '../../utils/formatters';
import { IconTrash } from '../common/Icons';

const emptyClient = {
  dni: '',
  name: '',
  surname: '',
  cuil: '',
  birthday: '',
  mail: '',
  phone: ''
};

const ClientModal = ({ isOpen, onClose, onSave, onDelete, initialData }) => {
  const [formData, setFormData] = useState(emptyClient);
  const [confirmOpen, setConfirmOpen] = useState(false);

  useEffect(() => {
    if (initialData) {
      setFormData({
        dni: formatDni(initialData.dni || ''),
        name: initialData.name || '',
        surname: initialData.surname || '',
        cuil: formatCuil(initialData.cuil || ''),
        birthday: initialData.birthday ? initialData.birthday.slice(0, 10) : '',
        mail: initialData.mail || '',
        phone: initialData.phone || ''
      });
    } else {
      setFormData(emptyClient);
    }
  }, [initialData, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const nextValue =
      (name === 'name' || name === 'surname')
        ? String(value).toUpperCase()
        : name === 'dni'
          ? formatDni(value)
          : name === 'cuil'
            ? formatCuil(value)
            : value;
    setFormData((prev) => ({ ...prev, [name]: nextValue }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    const cuilDigits = digitsOnly(formData.cuil);
    const phoneDigits = digitsOnly(formData.phone);
    onSave({
      ...formData,
      name: String(formData.name || '').toUpperCase(),
      surname: String(formData.surname || '').toUpperCase(),
      dni: digitsOnly(formData.dni),
      cuil: cuilDigits ? cuilDigits : null,
      phone: phoneDigits ? phoneDigits : null,
    });
  };

  return (
    <Modal
      title={initialData ? 'Editar Cliente' : 'Nuevo Cliente'}
      isOpen={isOpen}
      onClose={onClose}
      onEnter={() => handleSubmit()}
      footer={(
        <div className="modal-footer">
          <div className="footer-left">
            {initialData && (
              <button
                type="button"
                className="icon-btn icon-btn--delete"
                onClick={() => setConfirmOpen(true)}
                aria-label="Eliminar cliente"
                title="Eliminar"
              >
                <IconTrash />
              </button>
            )}
          </div>
          <div className="footer-actions">
            <button type="button" onClick={onClose} className="btn secondary">Cancelar</button>
            <button type="submit" form="client-modal-form" className="btn">Guardar</button>
          </div>
        </div>
      )}
    >
      <form id="client-modal-form" className="modal-form" onSubmit={handleSubmit}>
        <div className="form-grid two-columns">
          <label>
            Nombre
            <input name="name" value={formData.name} onChange={handleChange} required />
          </label>
          <label>
            Apellido
            <input name="surname" value={formData.surname} onChange={handleChange} required />
          </label>
          <label>
            DNI
            <input name="dni" value={formData.dni} onChange={handleChange} required />
          </label>
          <label>
            CUIL
            <input name="cuil" value={formData.cuil} onChange={handleChange} />
          </label>
          <label>
            Fecha de nacimiento
            <input type="date" name="birthday" value={formData.birthday} onChange={handleChange} required />
          </label>
          <label>
            Email
            <input type="email" name="mail" value={formData.mail} onChange={handleChange} />
          </label>
          <label>
            Teléfono
            <input name="phone" value={formData.phone} onChange={handleChange} />
          </label>
        </div>

      </form>

      <ConfirmDialog
        isOpen={confirmOpen}
        title="Eliminar cliente"
        message="¿Está seguro que desea eliminar este cliente y sus pasajeros asociados?"
        confirmLabel="Eliminar"
        cancelLabel="Cancelar"
        onConfirm={() => {
          setConfirmOpen(false);
          onDelete(initialData.id);
        }}
        onCancel={() => setConfirmOpen(false)}
      />
    </Modal>
  );
};

export default ClientModal;
